import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import PolitikaZasebnosti from "./pages/PolitikaZasebnosti";
import SplošniPogoji from "./pages/SplošniPogoji";
import ProjectDetail from "./pages/ProjectDetail";
import AtriumSezanaPage from "./pages/AtriumSezanaPage";
import { ScrollToTop } from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/projekt/:slug" element={<ProjectDetail />} />
          <Route path="/atrium-sezana" element={<AtriumSezanaPage />} />
          <Route path="/politika-zasebnosti" element={<PolitikaZasebnosti />} />
          <Route path="/splosni-pogoji" element={<SplošniPogoji />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
